<div class="merge-vehicle">
  <div class="ui-g-12 p-zero dialog-header">
    <div class="columns">
      <div class="icon">
        <div class="icon-circle ml-2"><i class="fal fa-car pt-1"></i></div>
      </div>
      <div class="text">
        <div class="font-16 font-bold black mt-2 tml-heading">
          Select a vehicle to merge with
          <span class=""> {{ primaryVehicle?.name }}</span>
        </div>
        <div class="font-10 font-500 gray-55 tml-sub-header">All details from the primary vehicle will be saved.</div>
      </div>
      <div class="close">
        <i class="fal fa-times fa-sm dialog-close font-500" (click)="closeDuplicateVehicleModal({})"></i>
      </div>
    </div>
  </div>

  <div class="dialog-body">
    <div class="ui-g-12">
      <!-- Select Vehicle -->
      <div class="ui-g-6 p-zero left-box">
        <p class="font-12 gray-35 font-600">Select vehicle</p>
        <div class="ui-g-10">
          <app-auto-complete
            id="estimate-vehicle"
            listId="estimate-vehicle-list"
            theme="border"
            name="est-vehicle"
            inactiveItemsKey="isActive"
            placeholder="Select vehicle"
            [hasEditableField]="true"
            [value]="secondaryVehicle && secondaryVehicle?._id ? (secondaryVehicle?.name || secondaryVehicle?.vehicleName):''"
            [suggestions]="vehicleSuggestion"
            [disabled]="false"
            [fontSize]="14"
            [hasCustomEditableField]="true"
            [isDropdownIconVisible]="isDropdownIcon"
            [showDisabledIcon]="false"
            [hasSearchIcon]="true"
            styleClassInput="text-ellipse bg-gray-75 width-240"
            leftIcon="fal fa-car font-gray font-14"
            scrollHeight="337px"
            [textTruncate]="true"
            noRecordIcon="fal fa-car pr-2"
            (appChange)="handleChange($event)"
            (appSelect)="onSelectVehicle($event)"
            (appCompletedMethod)="searchSuggestion($event)"
            (appClear)="onClearSuggestion()"
          >
            <ng-template let-item appTemplate="item">
              <div class="ui-g p-0" [ngClass]="{ 'inactive-vehicle': !item?.isActive }">
                <div class="ui-g-12 p-0 flex-start-start">
                  <div class="p-0">
                    <i class="fal fa-car p-2 pr-3"></i>
                  </div>

                  <div class="flex-column font-12" [ngClass]="{ 'inactive-vehicle': !item?.isActive }">
                    <span class="font-13 font-600 inactive-item-name">
                      {{ item?.name }}
                    </span>

                    <span class="font-12 inactive-item-number">
                      <span> License: {{ item?.licensePlateNo || noLicense }} </span>
                      <span> - </span>
                      <span>VIN: <span [innerHTML]="item?.VIN || noVIN | highlightVin"></span></span>
                    </span>
                  </div>
                </div>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>
        <div class="ui-g-2">
          <span *ngIf="secondaryVehicle?._id">
            <i
              class="far fa-link pointer font-green motor-position vehicle-link"
              *ngIf="secondaryVehicle?.isMotorConnected"
              tooltipPosition="top"
              tooltipStyleClass="motor-vehicle-link-tooltip font-11"
              [pTooltip]="'Connected to MOTOR'"
            ></i>
            <i
              class="far fa-link font-yellow pointer motor-position vehicle-link"
              *ngIf="!secondaryVehicle?.isMotorConnected"
              tooltipPosition="top"
              tooltipStyleClass="motor-vehicle-link-tooltip font-11"
              [pTooltip]="'Not connected to Motor'"
            ></i>
          </span>
          <span class="pl-3">
            <i *ngIf="secondaryVehicle._id" id="estimate-customer-clear" class="fal fa-times vehicle-clear pointer font-gray" (click)="onClearVehicle($event)"></i>
          </span>
        </div>

        <div class="ui-g-12">
          <div class="mt-2 pl-2 pt-2 vehicle-info-wrapper" *ngIf="secondaryVehicle?._id">
            <div class="font-14 font-secondary-700 font-600 text-truncate" tooltipPosition="bottom" [pTooltip]="getVehicleName(secondaryVehicle)">{{ getVehicleName(secondaryVehicle) }}</div>

            <div class="font-gray-45 font-14 vehicle-info">
              <div *ngIf="secondaryVehicle?.vehicleName" class="text-truncate" tooltipPosition="bottom" [pTooltip]="secondaryVehicle?.vehicleName">
                <span class="font-600">Vehicle name:</span> {{ secondaryVehicle?.vehicleName }}
              </div>
              <div *ngIf="!secondaryVehicle?.vehicleName" class="text-truncate" tooltipPosition="bottom" [pTooltip]="secondaryVehicle?.name">
                <span class="font-600">Vehicle name:</span> {{ secondaryVehicle?.name }}
              </div>
            </div>
            <div class="font-gray-45 font-14 vehicle-info">
              <span class="font-600">VIN:</span>
              <span class="text-truncate" tooltipPosition="bottom" [pTooltip]="secondaryVehicle?.VIN || ''"> {{ secondaryVehicle?.VIN || '' }}</span>
            </div>
            <div class="font-gray-45 font-14 vehicle-info">
              <span class="font-600">License plate:</span>
              <span class=""> {{ secondaryVehicle?.licensePlateNo || '' }}</span>
            </div>
            <div class="font-gray-45 font-14 vehicle-info">
              <span class="font-600">Registration state:</span>
              <span class=""> {{ secondaryVehicle?.registrationState || '' }}</span>
            </div>

            <div [@toggleBox]="isOpenSecondary ? 'open' : 'closed'">
              <span [hidden]="!isOpenSecondary">
                <div class="font-gray-45 font-14 vehicle-info">
                  <span class="font-600">Transmission:</span>
                  <span class="capitalize" *ngIf="isVehicleSidePanel"> {{ secondaryVehicle?.transmission?.label }}</span>
                  <span class="capitalize" *ngIf="!isVehicleSidePanel"> {{ secondaryVehicle?.transmission }}</span>
                </div>
                <div class="font-gray-45 font-14 vehicle-info">
                  <span class="font-600">Mileage:</span>
                  <span class="" *ngIf="isVehicleSidePanel">
                    {{ secondaryVehicle?.mileage || '' }} {{ secondaryVehicle.mileageMeasuringUnit?.value ? (secondaryVehicle.mileageMeasuringUnit?.value === 'mi' ? 'miles' : 'km') : '' }}</span
                  >
                  <span class="" *ngIf="!isVehicleSidePanel && ODMsecondary && ODMsecondary.reading">
                    {{ ODMsecondary.reading || '' }} {{ ODMsecondary.mileageMeasuringUnit ? (ODMsecondary.mileageMeasuringUnit === 'mi' ? 'miles' : 'km') : '' }}</span
                  >
                </div>
                <div class="font-gray-45 font-14 vehicle-info">
                  <div class="text-truncate" tooltipPosition="bottom" [pTooltip]="secondaryVehicle?.engine || ''">
                    <span class="font-600">Engine:</span>
                    {{ secondaryVehicle?.engine || '' }}
                  </div>
                </div>
              </span>
            </div>

            <div class="font-gray-45 font-14 vehicle-info pointer">
              <span class="" [hidden]="isOpenSecondary" (click)="toggleSecondary()">
                Show more
                <span class=""><i class="icon fal pl-1 fal font-14 font-600 fa-chevron-down"></i> </span>
              </span>
              <span class="" [hidden]="!isOpenSecondary" (click)="toggleSecondary()"
                >Show less
                <span class=""><i class="icon fal pl-1 fal font-14 font-600 fa-chevron-up"></i> </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Merge selected vehicle -->
      <div class="ui-g-6 p-zero right-box">
        <p class="font-12 gray-35 font-600">Merge selected vehicle into</p>
        <div class="ui-g-10">
          <div class="vehicle-autocomplete">
            <app-auto-complete
              id="estimate-vehicle"
              listId="estimate-vehicle-list"
              theme="border"
              name="est-vehicle"
              placeholder="Select vehicle"
              [hasEditableField]="true"
              [value]="primaryVehicle.name"
              [disabled]="isDialogOpen ? false : true"
              [fontSize]="14"
              [showDisabledIcon]="true"
              [hasSearchIcon]="true"
              [textTruncate]="true"
              styleClassInput="text-ellipse bg-gray-75 width-240"
              leftIcon="fal fa-car font-gray font-14"
              scrollHeight="337px"
              noRecordIcon="fal fa-car pr-2"
              [suggestions]="primaryVehicleSuggestion"
              [hasCustomEditableField]="isDialogOpen ? true : false"
              [isDropdownIconVisible]="isDialogOpen ? isPrimaryDropdownIcon : false"
              (appChange)="handleChange($event, true)"
              (appSelect)="onSelectVehicle($event, true)"
              (appCompletedMethod)="searchSuggestion($event, true)"
              (appClear)="onClearSuggestion(true)"
            >
              <ng-template let-item appTemplate="item" [ngIf]="isDialogOpen">
                <div class="ui-g p-0" [ngClass]="{ 'inactive-vehicle': !item?.isActive }">
                  <div class="ui-g-12 p-0 flex-start-start">
                    <div class="p-0">
                      <i class="fal fa-car p-2 pr-3"></i>
                    </div>

                    <div class="flex-column font-12" [ngClass]="{ 'inactive-vehicle': !item?.isActive }">
                      <span class="font-13 font-600 inactive-item-name">
                        {{ item?.name }}
                      </span>

                      <span class="font-12 inactive-item-number">
                        <span> License: {{ item?.licensePlateNo || noLicense }} </span>
                        <span> - </span>
                        <span>VIN: <span [innerHTML]="item?.VIN || noVIN | highlightVin"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>
        <div class="ui-g-2 motor-position">
          <span *ngIf="primaryVehicle?._id">
            <i
              class="far fa-link pointer font-green"
              *ngIf="primaryVehicle?.isMotorConnected"
              tooltipPosition="top"
              tooltipStyleClass="motor-vehicle-link-tooltip font-11"
              [pTooltip]="'Connected to MOTOR'"
            ></i>
            <i
              class="far fa-link font-yellow pointer"
              *ngIf="!primaryVehicle?.isMotorConnected"
              tooltipPosition="top"
              tooltipStyleClass="motor-vehicle-link-tooltip font-11"
              [pTooltip]="'Not connected to Motor'"
            ></i>
            <i *ngIf="isDialogOpen" id="estimate-customer-clear" class="ml-3 fal fa-times vehicle-clear pointer font-gray" (click)="onClearVehicle($event, true)"></i>
          </span>
        </div>

        <div class="ui-g-12">
          <div class="mt-2 pl-2 pt-2 vehicle-info-wrapper" *ngIf="primaryVehicle?._id">
            <div class="font-14 font-secondary-700 font-600 text-truncate" tooltipPosition="bottom" [pTooltip]="getVehicleName(primaryVehicle)">{{ getVehicleName(primaryVehicle) }}</div>

            <div class="font-gray-45 font-14 vehicle-info">
              <div *ngIf="primaryVehicle?.vehicleName" class="text-truncate" tooltipPosition="bottom" [pTooltip]="primaryVehicle?.vehicleName">
                <span class="font-600">Vehicle name:</span> {{ primaryVehicle?.vehicleName }}
              </div>
              <div *ngIf="!primaryVehicle?.vehicleName" class="text-truncate" tooltipPosition="bottom" [pTooltip]="primaryVehicle?.name">
                <span class="font-600">Vehicle name:</span> {{ primaryVehicle?.name }}
              </div>
            </div>
            <div class="font-gray-45 font-14 vehicle-info">
              <span class="font-600">VIN:</span>
              <span class="text-truncate" tooltipPosition="bottom" [pTooltip]="primaryVehicle?.VIN || ''"> {{ primaryVehicle?.VIN || '' }}</span>
            </div>
            <div class="font-gray-45 font-14 vehicle-info">
              <span class="font-600">License plate:</span>
              <span class=""> {{ primaryVehicle?.licensePlateNo || '' }}</span>
            </div>
            <div class="font-gray-45 font-14 vehicle-info">
              <span class="font-600">Registration state:</span>
              <span> {{ primaryVehicle?.registrationState || '' }}</span>
            </div>

            <div [@toggleBox]="isOpenPrimary ? 'open' : 'closed'">
              <span [hidden]="!isOpenPrimary">
                <div class="font-gray-45 font-14 vehicle-info">
                  <span class="font-600">Transmission:</span>
                  <span class="capitalize" *ngIf="isVehicleSidePanel"> {{ primaryVehicle?.transmission?.label }}</span>
                  <span class="capitalize" *ngIf="!isVehicleSidePanel"> {{ primaryVehicle?.transmission }}</span>
                </div>
                <div class="font-gray-45 font-14 vehicle-info">
                  <span class="font-600">Mileage:</span>
                  <span class="" *ngIf="isVehicleSidePanel">
                    {{ primaryVehicle?.mileage || '' }} {{ primaryVehicle.mileageMeasuringUnit?.value ? (primaryVehicle.mileageMeasuringUnit?.value === 'mi' ? 'miles' : 'km') : '' }}</span
                  >
                  <span class="" *ngIf="!isVehicleSidePanel && ODM && ODM.reading">
                    {{ ODM.reading || '' }} {{ ODM.mileageMeasuringUnit ? (ODM.mileageMeasuringUnit === 'mi' ? 'miles' : 'km') : '' }}</span
                  >
                </div>
                <div class="font-gray-45 font-14 vehicle-info">
                  <div class="text-truncate" tooltipPosition="bottom" [pTooltip]="primaryVehicle?.engine || ''">
                    <span class="font-600">Engine:</span>
                    {{ primaryVehicle?.engine || '' }}
                  </div>
                </div>
              </span>
            </div>

            <div class="font-gray-45 font-14 vehicle-info pointer">
              <span class="" [hidden]="isOpenPrimary" (click)="togglePrimary()"
                >Show more
                <span class=""><i class="icon fal pl-1 fal font-14 font-600 fa-chevron-down"></i> </span>
              </span>
              <span class="" [hidden]="!isOpenPrimary" (click)="togglePrimary()"
                >Show less
                <span class=""><i class="icon fal pl-1 fal font-14 font-600 fa-chevron-up"></i> </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="p-zero text-right float-right merge-vehicle-footer mt-1 mb-1">
      <button id="merge-vehicle-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-1" (click)="closeDuplicateVehicleModal({})">Cancel</button>
      <button id="merge-vehicle-btn-save" class="btn btn-primary btn-submit font-bold" [disabled]="!secondaryVehicle?._id" (click)="handleSubmit()">
        <span class="" [ngClass]="{ 'pr-2': isProcessing }">Merge</span>
        <i *ngIf="isProcessing" class="fal fa-spinner rotate ml-1"></i>
      </button>
    </div>
  </div>
</div>
